export const state = {
  map: null,
  map2: null,
  isCompareMode: false,
  draw: null,
  mapReady: false,
  map2Ready: false,
  features: {
    type: 'FeatureCollection',
    features: []
  },
  feedFeatures: {
    type: 'FeatureCollection',
    features: []
  },

  orgLayers: [],

  currentFeature: null,
  currentFeatureChilds: null,

  page: 1,
  perPage: 10,

  planetFeaturesEnabled: false,
  beacons: [],

  notes: [],

  tilesSettings: null,
  tilesMosaics: [],

  files: null,
  layers: null,
  reportTemplates: null,
  allTemplates: null,
  systemTemplatesLibrary: null,

  isFeatureCreated: false,
  totalOnMap: 0,

  // Heavy feature geometry cache - loaded on demand for features with >5000 points
  loadedHeavyGeometries: {},
  heavyFeatureLoading: {},

  // Feature visibility state - tracks which features are visible on map
  // Key: feature code, Value: boolean (true = visible, false = hidden)
  featureVisibility: {},
  
  // Resources state for media uploads
  resources: [],

  // Project-level filters (shared between feed and map)
  projectFilters: null,
}
